import { UserType } from '../../../../../types/UserType';
import { Text } from '../../../../cdl/Text/Text';
import { HeaderWithLine } from '../../../../common/HeaderWithLine/HeaderWithLine';
import { translate } from '../../../../common/helpers/translate.helper';
import { Box } from '../../../../common/ui/Box';
import { ApiKeyDescription } from '../../../components/ApiKeyDescription';
import { ApiKeysTable } from '../../../components/ApiKeysTable';
import { CreateApiKeyButton } from '../../../components/CreateApiKeyButton';

interface SupplierDevelopersTabProps {
    groupId: string;
}

export const SupplierDevelopersTab = ({ groupId }: SupplierDevelopersTabProps) => {
    return (
        <Box display="flex" flexDirection="column" gap={48}>
            <Box display="flex" flexDirection="column" gap={16}>
                <HeaderWithLine description={<ApiKeyDescription />}>
                    <Text variant="subtitle1" as="h2">
                        {translate('apikey.title')}
                    </Text>

                    <CreateApiKeyButton groupId={groupId} userType={UserType.SUPPLIER} />
                </HeaderWithLine>
                <ApiKeysTable groupId={groupId} userType={UserType.SUPPLIER} />
            </Box>
        </Box>
    );
};
